import { render, staticRenderFns } from "./BinderTemplateContainer.vue?vue&type=template&id=7adb7aa8&"
import script from "./BinderTemplateContainer.vue?vue&type=script&lang=js&"
export * from "./BinderTemplateContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports